// Created by PeakXin on 2026/07/06.
import request from '@/utils/request'

/**
 * 获取学生基础信息
 */
export function getStudentBase() {
  return request({
    url: '/v1/student/base',
    method: 'get'
  })
}

/**
 * 获取学生详细信息
 */
export function getStudentDetail() {
  return request({
    url: '/v1/student/detail',
    method: 'get'
  })
}
